export default {
  name: 'ScheduleTasksQueueList',
  data () {
    return {
      items: [],
      loading: true,
      currentReq: null,
      paging: {
        limit: 10,
        total: 0,
        page: 1,
        pages: 1
      }
    }
  },
  props: {
    modelClassId: {
      type: Number | String,
      default: null
    },
    isModal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    tableHeaders () {
      const headers = [
        { key: 'created_at', label: this.$t('general.item.date'), type: 'datetime' },
        { key: 'callfunc', label: this.$t('scheduled-task.callfunc') },
        { key: 'params', label: this.$t('scheduled-task.params'), type: 'slot', slotcode: 'queue-params' },
        { key: 'info', label: this.$t('scheduled-task.info'), type: 'slot', slotcode: 'queue-info' },
        { key: 'status_id', label: this.$t('scheduled-task.status'), format: 'formatFromConfig', configKey: 'scheduled_task_statuses', configParam: 'name' },
        { key: 'actions', label: '', actions: [] }
      ];
      return headers;
    },
    componentName () {
      if (this.isModal) {
        return 'b-modal';
      }
      return 'div';
    },
    title () {
      return this.$t('scheduled-task.queue-list.title');
    }
  },
  methods: {
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      const self = this;
      let path = 'scheduled-tasks/list-queue';
      if (this.modelClassId) {
        path += '/' + this.modelClassId;
      }
      path = path + '?perPage=' + this.paging.limit + '&page=' + this.paging.page;
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          self.items = response.data;
          self.paging = response.paging;
          self.loading = false;
        }
      });
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    show () {
      this.getTableData();
      this.$refs['modal-window'].show();
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  },
  mounted () {
    if (!this.isModal) {
      this.getTableData();
    }
  }
}
